import { Grid } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import GlobalForm from '../../utility/formWiz/globalForm';
import styles from '../../../assets/styles/componentStyles/chatbotStyles/chatbotSettings.module.scss'
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import { DEFAULT_MODELS_BASED_ON_AI_LLM_PLATFORM, filterGptModelsBasedOnAILLMPlatform, getFileTypeImgIcon } from '../../../utils/constants';
import { GenericDataContext, GenericDataContextPayload } from '../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, homeBreadcrumb } from '../../../utils/breadcrumb';
import agent from '../../../services/api';
import { gptModels } from '../../../models/axiosModel';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface ChatbotSettingSectionInterface {
    flagSmallScreen: boolean,
    flagMobileScreen: boolean,
    setCreateChatbotFormData: any,
    createChatbotFormData: any,
    files: any,
    setFiles: any,
    currentTab: string
    setFieldValueOfTheme?: any
}

const ChatbotSettings = (props: ChatbotSettingSectionInterface) => {


    const {
        flagMobileScreen,
        flagSmallScreen,
        createChatbotFormData,
        setCreateChatbotFormData,
        setFiles,
        files,
        setFieldValueOfTheme

    } = props

    const { UpdateChatbotApi, chatBotDetails, setChatbotThemeDetails } = useContext(ChatbotContext) as ChatbotContextPayload
    const { setBreadCrumbs, gptModelList, AILLMPlatformList } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))

    const [renderValue, setRenderValue] = useState({
        status: null,
        message: "",
        submission_id: null
    })
    const [submissionID, setsubmissionID] = useState(null);
    let pathname = window.location.pathname.toLowerCase();

    const [progress, setProgress] = useState({ filename: "", percent: 0 });


    const formSubmitFunction = async (data: any) => {
        var finalData = data;
    }

    const handleCloseSnackBar = () => {
        setRenderValue({
            status: null,
            message: "",
            submission_id: null
        })
    }

    const setFieldValue = (data: any) => {
        var tempdata = { ...createChatbotFormData }
        tempdata.data.global_form_field.map((newvalue: any) => {
            if (newvalue.options && data.field_option_data_id) {
                newvalue.options.map((option_value: any) => {
                    if (option_value.field_option_data_id == data.field_option_data_id) {
                        option_value.field_option_flag = data.page_field_value
                    }
                })
            }
            if(data.page_field_id == 1539){ // Deployment Platform
                if(newvalue.page_field_id == data.page_field_id){
                    newvalue.options = newvalue?.options?.map((option: any) => {
                        if(data?.field_option_data_id === option?.field_option_label){
                            return {
                                ...option,
                                field_option_value: true,
                            }
                        }
                        return {
                            ...option,
                            field_option_value: false,
                        }
                    })
                    // Save path reads field `.value` (see viewChatbot saveThemeSettings); keep it aligned with the selected option.
                    newvalue.value = data.field_option_data_id
                } else if(newvalue.page_field_id == 1538){ // GPT Models
                    const filteredModels = filterGptModelsBasedOnAILLMPlatform(gptModelList, AILLMPlatformList, data.field_option_data_id?.toLowerCase() === "azure", data.field_option_data_id?.toLowerCase() === "azure agent") 
                    newvalue.options = filteredModels;
                    
                    const defaultModel = filteredModels?.find((model: gptModels) => {
                        if(data.field_option_data_id?.toLowerCase() === "azure"){
                            return model?.gpt_model_name === DEFAULT_MODELS_BASED_ON_AI_LLM_PLATFORM['AZURE_OPENAI'];
                        } else if(data.field_option_data_id?.toLowerCase() === "azure agent"){
                            return model?.gpt_model_name === DEFAULT_MODELS_BASED_ON_AI_LLM_PLATFORM['AZURE_FOUNDRY'];
                        } else {
                            return model?.gpt_model_name === DEFAULT_MODELS_BASED_ON_AI_LLM_PLATFORM['OPENAI'];
                        }
                    })
                    newvalue.value = defaultModel ?? null;
                }
            } else if(newvalue.page_field_id === data.page_field_id) {
                newvalue.value = data.page_field_value
            }
            // if(data.page_field_id == 1540 && data.page_field_value && newvalue.page_field_id == 1539){
            //     newvalue.value = false;
            // }
            // if(data.page_field_id == 1539 && data.page_field_value && newvalue.page_field_id == 1540){
            //     newvalue.value = false;
            // }
        })
        setCreateChatbotFormData(tempdata)

        if (data.page_field_id == 1511) {
            setChatbotThemeDetails((prev: any) => ({
                ...prev,
                chatbot_name: data.page_field_value,
            }))
        }
        if (data.page_field_id == 1537) {
            setChatbotThemeDetails((prev: any) => ({
                ...prev,
                send_message_placeholder: data.page_field_value,
            }))
        }
    }

    const uploadFileHandler = async (event: any, id: any, removeFile: any) => {
        for (var i = 0; i < event.target.files.length; i++) {
            const file: any = event.target.files[i];
            file.isUploading = true;
            setFiles((old: any) => {
                let temp: any = [...old]
                temp.push(file)
                return temp
            })

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");
            let config = {
                onUploadProgress: (progressEvent: any) => {
                    const { loaded, total } = progressEvent;
                    var percent = Math.floor((loaded * 100) / total)
                    setProgress({ ...progress, percent: percent, filename: file.name })
                }
            }
            agent.uploadFile.post(formData, config).then(async (res) => {
                    if (res.status) {
                        file.isUploading = false;
                        file.file_data = res.data.data;


                        file.google_storage_id = res.data.data.google_storage_id;
                        await setFiles((old: any) => {
                            let temp = [...old]
                            let fileType = file.name.split('.').pop()
                            let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                            temp.map((rr: any) => {
                                if (rr.google_storage_id == file.google_storage_id) {
                                    rr.isUploading = false;
                                    rr.file_data = res.data.data;
                                    rr.google_storage_id = res.data.data.google_storage_id;
                                    rr.page_field_id = id;
                                    rr.previewImageSrc = fileTypeIconSrc;
                                }
                            })
                            var tempdata = { ...createChatbotFormData }
                            const googleStorageIds = temp.filter((item: any) => item.page_field_id == id);

                            tempdata.data.global_form_field.map((newvalue: any) => {
                                if (newvalue.page_field_id === id) {
                                    // debugger
                                    newvalue.value = googleStorageIds
                                }
                            })
                            setCreateChatbotFormData(tempdata)
                            return temp
                        })

                        let images = [];

                        for (let i = 0; i < event.target.files.length; i++) {
                            images.push(URL.createObjectURL(event.target.files[i]))
                        }
                    } else {
                        showError("Something went wrong!")
                        setFiles([])
                    }
                })
                .catch((err) => {
                    showError("Something went wrong!")
                    setFiles([])
                    // inform the user
                    console.error(err)
                    // removeFile(file.name)
                });
        }
    }

    const removeFile = (google_id: any, page_field_id: any) => {
        var google_s_id: any = {};
        google_s_id['file_id'] = google_id
        const fileSet: any = files.filter((file: any) => file.google_storage_id !== google_id)
        var finalFiles: any = [...fileSet];
        var tempdata = { ...createChatbotFormData }
        const googleStorageIds = finalFiles.map((item: any) => item.google_storage_id);

        tempdata.data.global_form_field.map((newvalue: any) => {
            if (newvalue.page_field_id === page_field_id) {
                newvalue.value = finalFiles.filter((file: any) => file.page_field_id == newvalue.page_field_id)
            }
        })
        setCreateChatbotFormData(tempdata)
        setFiles(finalFiles)
        // axios.delete(`${process.env.REACT_APP_BASE_URL}/api/storage/file?file_id=${google_id}`, {
        //     headers: { 'Content-Type': 'multipart/form-data' },
        //     withCredentials: true,
        // }
        // ).then(async (res) => {
        //     if (res.data.status) {
        //         const fileSet: any = files.filter((file: any) => file.google_storage_id !== google_id)
        //         var finalFiles: any = [...fileSet];
        //         var tempdata = { ...createChatbotFormData }
        //         const googleStorageIds = finalFiles.map((item: any) => item.google_storage_id);

        //         tempdata.data.global_form_field.map((newvalue: any) => {
        //             if (newvalue.page_field_id === page_field_id) {
        //                 newvalue.value = googleStorageIds
        //             }
        //         })
        //         setCreateChatbotFormData(tempdata)
        //         setFiles(finalFiles)
        //     } else {
        //         let errorCode = checkForErrorCode(res.data)
        //         if (ifUserMessageShouldBeDynamic(errorCode)) {
        //             setError((prevState) => ({ ...prevState, flagShowError: true, message: res.data.error.message }))
        //         } else {
        //             setError((prevState) => ({ ...prevState, flagShowError: true, message: getErrorMessage(errorCode, isDev(userDetail)) }))
        //         }
        //     }
        // }
        // ).catch((err) => {
        //     console.error(err)
        // });
    }

    useEffect(() => {
        const updatedBreadcrumbs = [
            { ...homeBreadcrumb},
            AIChatbotBreadcrumb,
            { ...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", isActive: true }
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12} className={flagSmallScreen ? styles.chatbotSettingsForm : ""}>
                            {props.currentTab == "Settings" &&
                                <GlobalForm
                                    fields={createChatbotFormData.data.global_form_field.slice(0, 18)}
                                    submitFunction={formSubmitFunction}
                                    checkFormSubmit={renderValue}
                                    handleCloseSnackBar={handleCloseSnackBar}
                                    pageThemeData={createChatbotFormData.data.doc_page_theme[0]}
                                    formData={createChatbotFormData.data}
                                    setFieldValue={setFieldValue}
                                    recaptchaFlag="true"
                                    defaultLoader={false}
                                    formEditable={true}
                                    uploadFileHandler={(e: any, id: any, removeFile: any) => { uploadFileHandler(e, id, removeFile) }}
                                    filesInParent={files}
                                    removeFile={(e: any, page_field_id: any) => { removeFile(e, page_field_id) }}
                                />}

                            {props.currentTab == "Theme Settings" &&
                                <GlobalForm
                                    fields={createChatbotFormData.data.global_form_field.slice(18)}
                                    // submitFunction={formSubmitFunction}
                                    checkFormSubmit={renderValue}
                                    // handleCloseSnackBar={handleCloseSnackBar}
                                    pageThemeData={createChatbotFormData.data.doc_page_theme[0]}
                                    formData={createChatbotFormData.data}
                                    submissionID={submissionID}
                                    setFieldValue={setFieldValueOfTheme}
                                    defaultLoader={false}
                                    formEditable={true}
                                    uploadFileHandler={(e: any, id: any, removeFile: any) => { uploadFileHandler(e, id, removeFile) }}
                                    filesInParent={files}
                                    // progressInParent={progress}
                                    removeFile={(e: any, page_field_id: any) => { removeFile(e, page_field_id) }}
                                />}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ChatbotSettings;